import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ITranslatedTableService } from 'app/admin/config/TranslatedTableConfig';

@Injectable({
  providedIn: 'root'
})
export class TaskTypeTranslationService implements ITranslatedTableService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/tasktypetranslation`;

  constructor(private http: HttpClient) { }

  getMany(languageId: number, includeMissing: boolean): Observable<Boo.Objects.TaskTypeTranslation[]> {
    const params = new HttpParams()
    .set('languageId', languageId)
    .set('includeMissing', includeMissing);

    return this.http.get<Boo.Objects.TaskTypeTranslation[]>(`${this.baseUrl}/GetMany`, { params: params });
  }

  saveMany(translations: Boo.Objects.TaskTypeTranslation[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/SaveMany`, translations);
  }
}
